export default {"src":"/_next/static/media/down_chevron_white.3ab667c1.svg","height":7,"width":10,"blurWidth":0,"blurHeight":0};